import { Component, OnInit } from '@angular/core';
import { ApiUserScope } from '@client/app/feature-modules/admin/modules/admin-api-tokens/types/api-user.type';
import { ApiTokensService } from '@client/app/feature-modules/admin/modules/admin-api-tokens/services/api-tokens.service';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoModule } from '@jsverse/transloco';

export type AddApiTokenDialogComponentModel = {
    scopes: ApiUserScope[],
    description: string
};

@Component({
    selector: 'mon-add-api-token-dialog',
    imports: [
        TranslocoModule,
        CheckboxModule,
        InputTextModule,
        FormsModule,
        Button,
    ],
    templateUrl: './add-api-token-dialog.component.html',
    styleUrl: './add-api-token-dialog.component.scss',
})
export class AddApiTokenDialogComponent implements OnInit {
    scopeOptions: {
        label: string;
        value: ApiUserScope;
    }[] = [];

    model: AddApiTokenDialogComponentModel = {
        scopes: [],
        description: '',
    };

    constructor (
        private readonly apiTokensService: ApiTokensService,
        private readonly dialogRef: DynamicDialogRef,
    ) {}

    ngOnInit (): void {
        const availableScopes = this.apiTokensService.getScopes();
        for (const scope of availableScopes) {
            this.scopeOptions.push({
                label: this.apiTokensService.getScopesTranslationMap().get(scope) || '',
                value: scope,
            });
        }
    }

    cancel (): void {
        this.dialogRef.close(null);
    }

    save (): void {
        this.dialogRef.close(this.model);
    }

}
